"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accessibleTransition = exports.focusOutline = exports.undoVisuallyHidden = exports.visuallyHidden = exports.alignHorizontal = exports.alignVertical = exports.alignCentre = exports.pseudo = exports.circle = exports.square = exports.buttonReset = exports.listReset = void 0;
const styled_components_1 = require("styled-components");
const theme_1 = require("@nib-components/theme");
const global_utils_1 = require("../utils/global-utils");
const vr = __importStar(require("./variables"));
// ----------------------------------------
// Resets
exports.listReset = (0, styled_components_1.css)`
  margin: 0;
  padding: 0;
  list-style: none;
`;
exports.buttonReset = (0, styled_components_1.css)`
  appearance: none;
  padding: 0;
  border: none;
  background: none;

  &:not(:disabled) {
    cursor: pointer;
  }
`;
// ----------------------------------------
// Sizes
const square = size => (0, styled_components_1.css)`
  width: ${size};
  height: ${size};
`;
exports.square = square;
const circle = size => (0, styled_components_1.css)`
  ${(0, exports.square)(size)}
  border-radius: 50%;
`;
exports.circle = circle;
// ----------------------------------------
// Pseudo
exports.pseudo = (0, styled_components_1.css)`
  content: "";
  position: absolute;
`;
// ----------------------------------------
// Alignment
exports.alignCentre = (0, styled_components_1.css)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
exports.alignVertical = (0, styled_components_1.css)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;
exports.alignHorizontal = (0, styled_components_1.css)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;
// ----------------------------------------
// Visually hidden
// - Method to hide text visually whilst keeping it there for screen readers
//
// Ref: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/
// Mixin styles sourced from: https://github.com/tailwindlabs/tailwindcss/pull/964
/* NOTE: A componentised version of the below can be found in
`src/core/utils/components/VisuallyHidden`. */
exports.visuallyHidden = (0, styled_components_1.css)`
  border-width: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
exports.undoVisuallyHidden = (0, styled_components_1.css)`
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  padding: 0;
  position: static;
  white-space: normal;
  width: auto;
`;
// ----------------------------------------
// Accessibility
exports.focusOutline = (0, styled_components_1.css)`
  outline: ${theme_1.focusOutlineWidth} ${theme_1.focusOutlineStyle} ${theme_1.focusOutlineColor};
  outline-offset: ${theme_1.focusOutlineOffset};
`;
const accessibleTransition = (properties, duration) => (0, styled_components_1.css)`
  transition-property: ${properties};
  transition-duration: ${(0, global_utils_1.doesPreferReducedMotion)() ? "0ms" : `${duration !== null && duration !== void 0 ? duration : vr.BASE_TRANSITION}ms`};
  will-change: ${properties};
`;
exports.accessibleTransition = accessibleTransition;